import { apiSlice } from "./http";
import { Paginated } from "src/@types/paginated";
import {
  ILackOfConciliation,
  ILackOfConciliationParams,
} from "src/@types/lack-of-conciliation";
import { Tags } from "@/enum/tags";

export interface IExportLackReportParams {
  reportType: string;
  startDate: string;
  endDate: string;
  responsibleId?: string;
  code?: string;
  regionalId?: string;
}

export const storeLackTransactionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    exportLackExcel: builder.mutation<string, IExportLackReportParams>({
      query: ({ reportType, startDate, endDate, responsibleId, code, regionalId }) => {
        const params = new URLSearchParams({ reportType, startDate, endDate });
        if (responsibleId) params.append("responsibleId", responsibleId);
        if (code) params.append("code", code);
        if (regionalId) params.append("regionalId", regionalId);

        return {
          url: `/conciliation-report/generate-report?${params.toString()}`,
          method: "GET",
          responseHandler: async (response: Response): Promise<string> => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonResponse = await response.json();
            return jsonResponse.excelFile;
          },
        };
      },
    }),
    exportLackPdf: builder.mutation<string, IExportLackReportParams>({
      query: ({ reportType, startDate, endDate, responsibleId, code, regionalId }) => {
        const params = new URLSearchParams({ reportType, startDate, endDate });
        if (responsibleId) params.append("responsibleId", responsibleId);
        if (code) params.append("code", code);
        if (regionalId) params.append("regionalId", regionalId);

        return {
          url: `/conciliation-report/generate-report/pdf?${params.toString()}`,
          method: "GET",
          responseHandler: async (response: Response): Promise<string> => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonResponse = await response.json();
            return jsonResponse.pdfFile;
          },
        };
      },
    }),
    getLackTransactions: builder.query<
      Paginated<ILackOfConciliation>,
      ILackOfConciliationParams
    >({
      query: ({ search, meta, perPage, orderBy, code, responsible, regional_id, register_code, transactionStartDate, transactionEndDate }) => {
        const params = new URLSearchParams({
          orderBy: orderBy.toString(),
          search,
          page: meta.page.toString(),
          perPage: (perPage ?? 10).toString(),

          ...(code !== undefined && { code: code?.toString() }),
          ...(responsible !== undefined && {
            operator: responsible?.toString(),
          }),
          ...(regional_id !== undefined && {
            regional_id: regional_id?.toString(),
          }),
          ...(register_code !== undefined && {
            register_code: register_code?.toString(),
          }),
          ...(transactionStartDate !== undefined && {
            transactionStartDate: transactionStartDate,
          }),
          ...(transactionEndDate !== undefined && {
            transactionEndDate: transactionEndDate,
          }),
        });

        return {
          url: `/store/get-lack-transactions?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.LACK_TRANSACTIONS],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetLackTransactionsQuery,
  useExportLackExcelMutation,
  useExportLackPdfMutation,
} = storeLackTransactionsApi;

export const {
  endpoints: {
    getLackTransactions: { select: selectGetLackTransactions },
  },
} = storeLackTransactionsApi;
